/**
 * Funzione helper generica per popolare una select da un array di oggetti.
 */
function populateSelect(selectElement, items, valueKey, textKey, selectedValue, placeholder) {
	selectElement.innerHTML = '';
	selectElement.add(new Option(placeholder, ''));
	if (items && Array.isArray(items)) {
		items.forEach(item => {
			const optionValue = item[valueKey];
			const optionText = item[textKey];
			const option = new Option(optionText, optionValue);
			if (optionValue == selectedValue) {
				option.selected = true;
			}
			selectElement.add(option);
		});

		if (selectElement.options.length === 2 && !selectedValue) {
			selectElement.selectedIndex = 1;
			selectElement.dispatchEvent(new Event('change'));
		}
	} else {
		selectElement.options[0].text = 'Nessun risultato';
	}
}

/**
 * Funzione helper per popolare una select da un array semplice di stringhe.
 */
function populateSimpleDropdown(selectElement, items, placeholder) {
	selectElement.innerHTML = '';
	selectElement.add(new Option(placeholder, ''));
	if (items && Array.isArray(items) && items.length > 0) {
		items.forEach(item => {
			selectElement.add(new Option(item, item));
		});

		if (selectElement.options.length === 2) {
			selectElement.selectedIndex = 1;
			selectElement.dispatchEvent(new Event('change'));
		}
	} else {
		selectElement.options[0].text = 'Nessuna opzione disponibile';
	}
}

/**
 * Funzione helper specifica per popolare la select delle prestazioni con logica di fallback.
 */
function populatePrestazioniSelect(selectElement, items, selectedValue, placeholder) {
	selectElement.innerHTML = '';
	selectElement.add(new Option(placeholder, ''));
	if (items && Array.isArray(items)) {
		items.forEach(item => {
			const optionValue = item.codice_onit || item.id_wp;
			const optionText = item.name;
			const option = new Option(optionText, optionValue);
			if (optionValue == selectedValue) {
				option.selected = true;
			}
			selectElement.add(option);
		});

		if (selectElement.options.length === 2 && !selectedValue) {
			selectElement.selectedIndex = 1;
			selectElement.dispatchEvent(new Event('change'));
		}
	} else {
		selectElement.options[0].text = 'Nessuna prestazione disponibile';
	}
}

/**
 * Rende i campi readonly.
 */
function makeFieldsReadOnly(elements) {
	elements.forEach(el => {
		if (!el) return;

		// Per le select, aggiunge solo la classe CSS per bloccare i click
		if (el.tagName === 'SELECT') {
			el.classList.add('disabled');
			el.onkeydown = (e) => e.preventDefault();

		}
		// Per i button, 'disabled' è ancora la scelta migliore
		else if (el.tagName === 'BUTTON') {
			el.disabled = true;
		}
		// Per gli altri input, 'readOnly' è perfetto
		else {
			el.readOnly = true;
		}
	});
}

/**
 * Trova il 'value' di un'opzione dal suo testo.
 */
function getOptionValueByText(selectElement, text) {
	const options = Array.from(selectElement.options);
	const foundOption = options.find(option => option.text.toLowerCase() === text.toLowerCase());
	return foundOption ? foundOption.value : null;
}

/**
 * Filtra e popola la select dei medici in modo affidabile (confrontando ID).
 */
function filterAndPopulateDoctors(prestazioneValue, allPrestazioniList, allDoctorsList, doctorSelect) {
	if (!prestazioneValue) {
		doctorSelect.innerHTML = '<option value="">Seleziona una prestazione</option>';
		doctorSelect.disabled = true;
		return;
	}
	if (!allPrestazioniList || !Array.isArray(allPrestazioniList)) {
		console.error("Lista prestazioni non valida in filterAndPopulateDoctors:", allPrestazioniList);
		doctorSelect.innerHTML = '<option value="">Errore: lista prestazioni non valida</option>';
		doctorSelect.disabled = true;
		return;
	}
	const selectedPrestazione = allPrestazioniList.find(p => (p.codice_onit || p.id_wp) == prestazioneValue);
	if (!selectedPrestazione) {
		doctorSelect.innerHTML = '<option value="">Errore: prestazione non trovata</option>';
		doctorSelect.disabled = true;
		return;
	}
	const filteredDoctors = allDoctorsList.filter(doctor =>
		doctor.strutture?.some(struttura =>
			struttura.prestazioni?.some(p => p.id_wp === selectedPrestazione.id_wp)
		)
	);
	if (filteredDoctors.length === 0) {
		doctorSelect.innerHTML = '';
		doctorSelect.add(new Option('Non è possibile scegliere un medico per questa prestazione', ''));
		doctorSelect.disabled = true;
	} else {
		populateSelect(doctorSelect, filteredDoctors, 'codice_fiscale', 'nome', null, 'Seleziona un medico...');
		doctorSelect.disabled = false;
	}
}

/**
 * SCENARIO 1: FORM DINAMICO STANDARD
 */
async function initializeDynamicSelects() {
	const provinceSelect = document.querySelector('.api-group-province select');
	const structureSelect = document.querySelector('.api-group-strutture select');
	const prestazioneSelect = document.querySelector('.api-group-tipologia-prestazione select');
	const doctorSelect = document.querySelector('.api-group-medici select');

	if (!provinceSelect || !structureSelect) {
		console.error("Errore: selettori non trovati");
		return;
	}

	let structuresData = [];
	let allDoctorsForStructure = [];
	let selectedStructure = null;

	structureSelect.disabled = true;
	if (prestazioneSelect) prestazioneSelect.disabled = true;
	if (doctorSelect) doctorSelect.disabled = true;

	// Questo event listener gestisce la logica Provincia -> Struttura
	provinceSelect.addEventListener('change', async (event) => {
		const provinceValue = event.target.value;

		if (prestazioneSelect) {
			prestazioneSelect.innerHTML = '<option value="">Seleziona una struttura</option>';
			prestazioneSelect.disabled = true;
		}
		if (doctorSelect) {
			doctorSelect.innerHTML = '<option value="">Seleziona una prestazione</option>';
			doctorSelect.disabled = true;
		}

		allDoctorsForStructure = [];
		selectedStructure = null;

		if (!provinceValue) {
			structureSelect.innerHTML = `<option value="">Seleziona prima una provincia</option>`;
			structureSelect.disabled = true;
			return;
		}

		structureSelect.disabled = true;
		structureSelect.innerHTML = '<option value="">Caricamento...</option>';
		const proxyUrl = `/wp-json/kgf/v1/proxy/api-group-strutture?value=${encodeURIComponent(provinceValue)}`;
		try {
			const response = await fetch(proxyUrl);
			console.log(proxyUrl);
			console.log(response);
			
			if (!response.ok) {
				const errorText = await response.text();
				console.error("Errore HTTP:", response.status, errorText);
				throw new Error(`HTTP ${response.status}: ${errorText}`);
			}
			
			structuresData = await response.json();
			console.log(structuresData);
			
			// Verifica che structuresData sia un array valido
			if (!Array.isArray(structuresData)) {
				console.warn("Risposta non è un array:", structuresData);
				structuresData = [];
			}
			
			populateSelect(structureSelect, structuresData, 'codice_onit', 'nome', null, 'Seleziona una struttura...');
			structureSelect.disabled = false;
		} catch (error) {
			console.error("Errore fetch strutture:", error);
			structureSelect.innerHTML = '<option value="">Errore nel caricamento</option>';
		}
	});

	if (structureSelect && prestazioneSelect) {
		structureSelect.addEventListener('change', async (event) => {
			const selectedStructureValue = event.target.value;

			if (doctorSelect) {
				doctorSelect.innerHTML = '<option value="">Seleziona una prestazione</option>';
				doctorSelect.disabled = true;
			}
			allDoctorsForStructure = [];

			if (!selectedStructureValue) {
				prestazioneSelect.innerHTML = '<option value="">Seleziona prima una struttura</option>';
				prestazioneSelect.disabled = true;
				return;
			}

			selectedStructure = structuresData.find(s => s.codice_onit == selectedStructureValue);
			if (!selectedStructure) return;

			// Verifica che prestazioni esista e sia un array
			if (!selectedStructure.prestazioni || !Array.isArray(selectedStructure.prestazioni)) {
				console.error("Prestazioni non disponibili o non valide per la struttura:", selectedStructure);
				prestazioneSelect.innerHTML = '<option value="">Nessuna prestazione disponibile</option>';
				prestazioneSelect.disabled = true;
				return;
			}

			populatePrestazioniSelect(prestazioneSelect, selectedStructure.prestazioni, null, 'Seleziona una prestazione...');
			prestazioneSelect.disabled = false;

			if (doctorSelect) {
				const structureId = selectedStructure.id_wp;
				const doctorsProxyUrl = `/wp-json/kgf/v1/proxy/api-group-medici?value=${structureId}`;
				try {
					const response = await fetch(doctorsProxyUrl);
					if (!response.ok) {
						throw new Error(`HTTP ${response.status}`);
					}
					allDoctorsForStructure = await response.json();
					if (!Array.isArray(allDoctorsForStructure)) {
						console.warn("Risposta medici non è un array:", allDoctorsForStructure);
						allDoctorsForStructure = [];
					}
				} catch (error) {
					console.error("Errore nel caricamento dei medici:", error);
					doctorSelect.innerHTML = '<option value="">Errore caricamento medici</option>';
					allDoctorsForStructure = [];
				}
			}
		});
	}

	if (prestazioneSelect && doctorSelect) {
		prestazioneSelect.addEventListener('change', (event) => {
			if (!selectedStructure || !selectedStructure.prestazioni || !Array.isArray(selectedStructure.prestazioni)) return;
			const prestazioneValue = event.target.value;

			filterAndPopulateDoctors(event.target.value, selectedStructure.prestazioni, allDoctorsForStructure, doctorSelect);
			updateSalesforceHiddenFields(prestazioneValue, selectedStructure.prestazioni);
		});
	}

	if (provinceSelect.value) {
		structureSelect.disabled = false;
	}

	if (structureSelect.value) {
		if (prestazioneSelect) {
			prestazioneSelect.disabled = false;
		}
	}

	if (prestazioneSelect && prestazioneSelect.value) {
		if (doctorSelect) {
			doctorSelect.disabled = false;
		}
	}

}

/**
 * SCENARIO 2: FORM PRECOMPILATO DA PAGINA STRUTTURA
 */
async function initializePreselectedForm(formWrapper, structureId) {
	const provinceSelect = formWrapper.querySelector('.api-group-province select');
	const structureSelect = formWrapper.querySelector('.api-group-strutture select');
	const prestazioneSelect = formWrapper.querySelector('.api-group-tipologia-prestazione select');
	const doctorSelect = formWrapper.querySelector('.api-group-medici select');

	if (!provinceSelect || !structureSelect) return;

	try {
		const proxySingleUrl = `/wp-json/kgf/v1/proxy/api-group-struttura-singola?id=${structureId}`;
		const singleResponse = await fetch(proxySingleUrl);
		
		if (!singleResponse.ok) {
			const errorText = await singleResponse.text();
			console.error("Errore HTTP nel caricamento struttura:", singleResponse.status, errorText);
			structureSelect.innerHTML = '<option value="">Errore nel caricamento</option>';
			return;
		}
		
		const structureData = await singleResponse.json();

		// Il proxy ora restituisce un oggetto singolo, non un array
		// Se per qualche motivo è ancora un array, prendi il primo elemento
		const structure = Array.isArray(structureData) ? structureData[0] : structureData;
		console.log(structure);

		if (!structure || typeof structure !== 'object' || !structure.provincia) {
			console.error("Dati della struttura non trovati o incompleti:", structureData);
			structureSelect.innerHTML = '<option value="">Dati struttura incompleti</option>';
			return;
		}

		if (!structure.codice_onit) {
			console.error(`La struttura con ID ${structureId} non ha un codice_onit. Impossibile preselezionare.`);
			structureSelect.innerHTML = '<option value="">Codice struttura mancante</option>';
			makeFieldsReadOnly([provinceSelect, structureSelect]);
			return;
		}

		const provinceValue = getOptionValueByText(provinceSelect, structure.provincia);
		if (provinceValue) {
			provinceSelect.value = provinceValue;
		}

		structureSelect.innerHTML = '';
		const option = new Option(structure.nome, structure.codice_onit);
		option.selected = true;
		structureSelect.add(option);

		makeFieldsReadOnly([provinceSelect, structureSelect]);

		fetch(`/wp-json/kgf/v1/proxy/api-group-strutture?value=${provinceValue}`)
			.then(res => {
				if (!res.ok) {
					throw new Error(`HTTP ${res.status}`);
				}
				return res.json();
			})
			.then(structuresList => {
				if (!Array.isArray(structuresList)) {
					console.warn("Risposta strutture non è un array:", structuresList);
					structuresList = [];
				}
				populateSelect(structureSelect, structuresList, 'codice_onit', 'nome', structure.codice_onit, 'Seleziona...');
				makeFieldsReadOnly([structureSelect]);
			})
			.catch(error => {
				console.error("Errore nel caricamento in background delle strutture:", error);
			});

		if (prestazioneSelect) {
			// Verifica che prestazioni esista e sia un array
			if (!structure.prestazioni || !Array.isArray(structure.prestazioni)) {
				console.error("Prestazioni non disponibili o non valide per la struttura:", structure);
				prestazioneSelect.innerHTML = '<option value="">Nessuna prestazione disponibile</option>';
				prestazioneSelect.disabled = true;
				makeFieldsReadOnly([prestazioneSelect]);
			} else {
				let allDoctorsForStructure = [];
				if (doctorSelect) {
					try {
						const doctorsProxyUrl = `/wp-json/kgf/v1/proxy/api-group-medici?value=${structureId}`;
						const doctorsResponse = await fetch(doctorsProxyUrl);
						if (!doctorsResponse.ok) {
							throw new Error(`HTTP ${doctorsResponse.status}`);
						}
						allDoctorsForStructure = await doctorsResponse.json();
						if (!Array.isArray(allDoctorsForStructure)) {
							console.warn("Risposta medici non è un array:", allDoctorsForStructure);
							allDoctorsForStructure = [];
						}
					} catch (e) {
						console.error("Errore caricamento medici:", e);
						allDoctorsForStructure = [];
					}
				}

				populatePrestazioniSelect(prestazioneSelect, structure.prestazioni, null, 'Seleziona una prestazione...');
				prestazioneSelect.disabled = false;

				prestazioneSelect.addEventListener('change', (event) => {
					filterAndPopulateDoctors(event.target.value, structure.prestazioni, allDoctorsForStructure, doctorSelect);
				});
			}
		}
	} catch (error) {
		console.error("Errore generale durante la pre-selezione:", error);
	}
}

/**
 * SCENARIO 3: FORM PRECOMPILATO DA PAGINA MEDICO
 */
async function initializeMedicoForm(formWrapper, medicoId) {
	const medicoSelect = document.querySelector('.api-group-medici select');
	const provinciaSelect = document.querySelector('.api-group-province select');
	const structureSelect = document.querySelector('.api-group-strutture select');
	const prestazioneSelect = document.querySelector('.api-group-tipologia-prestazione select');
	if (!medicoSelect || !provinciaSelect || !structureSelect || !prestazioneSelect) return;

	let medicoData = null;
	let isInitializing = true; // Flag per evitare reset durante l'inizializzazione

	// Salva i valori esistenti (in caso di errore di validazione)
	const savedProvinciaValue = provinciaSelect.value;
	const savedStructureValue = structureSelect.value;
	const savedPrestazioneValue = prestazioneSelect.value;

	provinciaSelect.disabled = true;
	structureSelect.disabled = true;
	prestazioneSelect.disabled = true;

	provinciaSelect.addEventListener('change', (event) => {
		const selectedProvince = event.target.value;

		// Non resettare la prestazione se stiamo solo inizializzando
		if (!isInitializing) {
			prestazioneSelect.innerHTML = '<option value="">Seleziona una struttura</option>';
			prestazioneSelect.disabled = true;
		}

		if (!selectedProvince) {
			structureSelect.innerHTML = '<option value="">Seleziona una provincia</option>';
			structureSelect.disabled = true;
			return;
		}
		const filteredStructures = medicoData.strutture.filter(s => s.provincia_short === selectedProvince);
		populateSelect(structureSelect, filteredStructures, 'codice_onit', 'name', savedStructureValue, 'Seleziona una struttura...');
		structureSelect.disabled = false;
	});

	structureSelect.addEventListener('change', (event) => {
		const selectedStructureCodiceOnit = event.target.value;
		if (!selectedStructureCodiceOnit) {
			if (!isInitializing) {
				prestazioneSelect.innerHTML = '<option value="">Seleziona una struttura</option>';
				prestazioneSelect.disabled = true;
			}
			return;
		}

		// Trova la struttura usando il codice_onit
		const structureInfo = medicoData.strutture.find(s => s.codice_onit == selectedStructureCodiceOnit);
		if (!structureInfo) {
			prestazioneSelect.innerHTML = '<option value="">Errore: struttura non trovata</option>';
			prestazioneSelect.disabled = true;
			return;
		}

		// Verifica che prestazioni esista e sia un array
		if (!structureInfo.prestazioni || !Array.isArray(structureInfo.prestazioni)) {
			prestazioneSelect.innerHTML = '<option value="">Nessuna prestazione disponibile</option>';
			prestazioneSelect.disabled = true;
			return;
		}

		// Preserva il valore salvato durante l'inizializzazione
		const prestazioneToSelect = isInitializing ? savedPrestazioneValue : null;
		populatePrestazioniSelect(prestazioneSelect, structureInfo.prestazioni, prestazioneToSelect, 'Seleziona una prestazione...');
		prestazioneSelect.disabled = false;
	});

	try {
		const proxyUrl = `/wp-json/kgf/v1/proxy/api-group-medico-singolo?id=${medicoId}`;
		const response = await fetch(proxyUrl);
		
		if (!response.ok) {
			const errorText = await response.text();
			console.error("Errore HTTP nel caricamento medico:", response.status, errorText);
			throw new Error(`HTTP ${response.status}: ${errorText}`);
		}
		
		medicoData = await response.json();
		if (!medicoData) throw new Error('Medico non trovato');

		if (medicoData.codice_fiscale) {
			populateSelect(medicoSelect, [medicoData], 'codice_fiscale', 'nome', medicoData.codice_fiscale, '---');
		} else {
			medicoSelect.innerHTML = '<option value="">Codice Fiscale non disponibile</option>';
		}
		makeFieldsReadOnly([medicoSelect]);

		const provinceObjects = medicoData.strutture
			.map(s => ({name: s.provincia, short: s.provincia_short}))
			.filter((province, index, self) =>
				province.short && index === self.findIndex(p => p.short === province.short)
			);

		// Popola provincia preservando il valore salvato
		populateSelect(provinciaSelect, provinceObjects, 'short', 'name', savedProvinciaValue, 'Seleziona una provincia...');
		provinciaSelect.disabled = false;

		// Se c'è un valore salvato di provincia, trigghera il caricamento della struttura
		if (savedProvinciaValue) {
			const filteredStructures = medicoData.strutture.filter(s => s.provincia_short === savedProvinciaValue);
			populateSelect(structureSelect, filteredStructures, 'codice_onit', 'name', savedStructureValue, 'Seleziona una struttura...');
			structureSelect.disabled = false;

			// Se c'è anche una struttura salvata, carica le prestazioni
			if (savedStructureValue) {
				const structureInfo = medicoData.strutture.find(s => s.codice_onit == savedStructureValue);
				if (structureInfo && structureInfo.prestazioni && Array.isArray(structureInfo.prestazioni)) {
					populatePrestazioniSelect(prestazioneSelect, structureInfo.prestazioni, savedPrestazioneValue, 'Seleziona una prestazione...');
					prestazioneSelect.disabled = false;
				}
			}
		}

		// Dopo l'inizializzazione, disabilita il flag
		setTimeout(() => {
			isInitializing = false;
		}, 100);

		prestazioneSelect.addEventListener('change', (event) => {
			const selectedStructureCodiceOnit = structureSelect.value;
			if (!selectedStructureCodiceOnit || !medicoData) return;

			const structureInfo = medicoData.strutture.find(s => s.codice_onit == selectedStructureCodiceOnit);
			if (!structureInfo) return;

			updateSalesforceHiddenFields(event.target.value, structureInfo.prestazioni);
		});
	} catch (error) {
		console.error("Errore init form medico:", error);
	}
}


/**
 * SCENARIO 4: FORM PRECOMPILATO DA PAGINA PRESTAZIONE
 */
async function initializePrestazioneForm(formWrapper, structureId, prestazioneId) {
	// Seleziona tutti i campi potenziali
	const provinceSelect = formWrapper.querySelector('.api-group-province select');
	const structureSelect = formWrapper.querySelector('.api-group-strutture select');
	const prestazioneSelect = formWrapper.querySelector('.api-group-tipologia-prestazione select');
	const doctorSelect = formWrapper.querySelector('.api-group-medici select');

	// Per questo scenario, i campi Struttura e Prestazione sono essenziali.
	// Se mancano, la funzione non può eseguire il suo compito principale.
	if (!structureSelect || !prestazioneSelect) {
		console.error("Impossibile eseguire initializePrestazioneForm: i campi Struttura o Prestazione sono mancanti nel form.");
		return;
	}

	try {
		// 1. Carica i dati della struttura corrente
		const proxySingleUrl = `/wp-json/kgf/v1/proxy/api-group-struttura-singola?id=${structureId}`;
		const singleResponse = await fetch(proxySingleUrl);
		
		if (!singleResponse.ok) {
			const errorText = await singleResponse.text();
			console.error("Errore HTTP nel caricamento struttura:", singleResponse.status, errorText);
			structureSelect.innerHTML = '<option value="">Errore nel caricamento</option>';
			return;
		}
		
		const structureDataRaw = await singleResponse.json();

		// Il proxy ora restituisce un oggetto singolo, non un array
		// Se per qualche motivo è ancora un array, prendi il primo elemento
		const structureData = Array.isArray(structureDataRaw) ? structureDataRaw[0] : structureDataRaw;

		if (!structureData || typeof structureData !== 'object') {
			console.error("Dati della struttura non trovati o non validi:", structureDataRaw);
			structureSelect.innerHTML = '<option value="">Dati struttura non trovati</option>';
			return;
		}

		if (!structureData.nome || !structureData.codice_onit) {
			console.error("Dati della struttura incompleti:", structureData);
			structureSelect.innerHTML = '<option value="">Dati struttura incompleti</option>';
			return;
		}

		// 2. Gestisce la Provincia (se esiste)
		if (provinceSelect && structureData.provincia) {
			const provinceValue = getOptionValueByText(provinceSelect, structureData.provincia);
			if (provinceValue) {
				provinceSelect.value = provinceValue;
			}
		}

		// 3. Popola e pre-seleziona la Struttura
		structureSelect.innerHTML = '';
		const structureOption = new Option(structureData.nome, structureData.codice_onit);
		structureOption.selected = true;
		structureSelect.add(structureOption);

		// 4. Popola e pre-seleziona la Prestazione
		// Verifica che prestazioni esista e sia un array
		if (!structureData.prestazioni || !Array.isArray(structureData.prestazioni)) {
			console.error("Prestazioni non disponibili o non valide per la struttura:", structureData);
			prestazioneSelect.innerHTML = '<option value="">Nessuna prestazione disponibile</option>';
			makeFieldsReadOnly([provinceSelect, structureSelect, prestazioneSelect]);
			return;
		}

		populatePrestazioniSelect(prestazioneSelect, structureData.prestazioni, null, 'Seleziona...');
		const currentPrestazione = structureData.prestazioni.find(p => p.id_wp == prestazioneId);
		if (currentPrestazione) {
			// Assicurati di usare il valore corretto (codice_onit se esiste)
			const prestazioneValue = currentPrestazione.codice_onit || currentPrestazione.id_wp;
			prestazioneSelect.value = prestazioneValue;
		}

		// 5. Disabilita tutti i campi che sono stati gestiti
		makeFieldsReadOnly([provinceSelect, structureSelect, prestazioneSelect]);

		// 6. Gestisce i Medici (se il campo esiste)
		if (doctorSelect) {
			try {
				const doctorsProxyUrl = `/wp-json/kgf/v1/proxy/api-group-medici?value=${structureId}`;
				const doctorsResponse = await fetch(doctorsProxyUrl);
				
				if (!doctorsResponse.ok) {
					throw new Error(`HTTP ${doctorsResponse.status}`);
				}
				
				const allDoctorsForStructure = await doctorsResponse.json();
				
				if (!Array.isArray(allDoctorsForStructure)) {
					console.warn("Risposta medici non è un array:", allDoctorsForStructure);
					allDoctorsForStructure = [];
				}

				filterAndPopulateDoctors(prestazioneSelect.value, structureData.prestazioni, allDoctorsForStructure, doctorSelect);
			} catch (error) {
				console.error("Errore nel caricamento dei medici:", error);
				doctorSelect.innerHTML = '<option value="">Errore caricamento medici</option>';
			}
		}

	} catch (error) {
		console.error("Errore durante la pre-selezione da pagina prestazione:", error);
	}
}

function updateSalesforceHiddenFields(selectedValue, prestazioniList) {
	// Cerca l'elemento <input> all'interno del contenitore del campo
	// a cui hai assegnato la classe CSS personalizzata.
	const sorgenteField = document.querySelector('.gf-sorgente-prestazione input');
	const descrizioneField = document.querySelector('.gf-descrizione-prestazione input');

	if (!sorgenteField || !descrizioneField) {
		console.warn('Campi nascosti per Salesforce non trovati. Assicurati che le classi CSS "gf-sorgente-prestazione" and "gf-descrizione-prestazione" siano state aggiunte ai campi corretti.');
		return;
	}

	if (!selectedValue) {
		sorgenteField.value = 'Klinika'; // Valore di default se nessuna prestazione è selezionata
		descrizioneField.value = '';
		return;
	}

	// Verifica che prestazioniList sia valido
	if (!prestazioniList || !Array.isArray(prestazioniList)) {
		console.warn('Lista prestazioni non valida per updateSalesforceHiddenFields:', prestazioniList);
		sorgenteField.value = 'Klinika';
		descrizioneField.value = '';
		return;
	}

	// Trova l'oggetto completo della prestazione selezionata
	const selectedPrestazione = prestazioniList.find(p => (p.codice_onit || p.id_wp) == selectedValue);

	if (selectedPrestazione) {
		// Controlla se la prestazione NON ha il codice_onit (quindi si usa l'ID)
		if (!selectedPrestazione.codice_onit) {
			sorgenteField.value = 'Sito web';
			descrizioneField.value = selectedPrestazione.name;
		} else {
			// Altrimenti, imposta il valore di default
			sorgenteField.value = 'Klinika';
			descrizioneField.value = '';
		}
	} else {
		// Fallback nel caso in cui la prestazione non venga trovata
		sorgenteField.value = 'Klinika';
		descrizioneField.value = '';
	}
}

async function initializeCascadingPrestazioneForm(formWrapper, prestazioneId) {
	const provinceSelect = formWrapper.querySelector('.api-group-province select');
	const structureSelect = formWrapper.querySelector('.api-group-strutture select');
	const prestazioneSelect = formWrapper.querySelector('.api-group-tipologia-prestazione select');
	const doctorSelect = formWrapper.querySelector('.api-group-medici select');

	if (!provinceSelect || !structureSelect || !prestazioneSelect) {
		console.error("Campi essenziali (provincia, struttura, prestazione) non trovati.");
		return;
	}

	provinceSelect.innerHTML = '<option value="">Caricamento...</option>';
	provinceSelect.disabled = true;
	structureSelect.disabled = true;
	if (doctorSelect) doctorSelect.disabled = true;

	try {
		const proxyUrl = `/wp-json/kgf/v1/proxy/api-group-prestazione-singola?id=${prestazioneId}`;
		const response = await fetch(proxyUrl);
		
		if (!response.ok) {
			const errorText = await response.text();
			console.error("Errore HTTP nel caricamento prestazione:", response.status, errorText);
			prestazioneSelect.innerHTML = '<option value="">Errore nel caricamento</option>';
			provinceSelect.innerHTML = '<option value="">Errore nel caricamento</option>';
			return;
		}
		
		const prestazioneData = await response.json();
		
		if (!prestazioneData) {
			console.error("Dati della prestazione non trovati.");
			prestazioneSelect.innerHTML = '<option value="">Dati prestazione non trovati</option>';
			provinceSelect.innerHTML = '<option value="">Nessuna provincia disponibile</option>';
			structureSelect.innerHTML = '<option value="">Nessuna struttura disponibile</option>';
			return;
		}

		// Il proxy ora restituisce un oggetto singolo, non un array
		// Se per qualche motivo è ancora un array, prendi il primo elemento
		// Controlla prima se è un array vuoto
		if (Array.isArray(prestazioneData) && prestazioneData.length === 0) {
			console.error("Dati della prestazione non trovati: array vuoto");
			prestazioneSelect.innerHTML = '<option value="">Dati prestazione non trovati</option>';
			provinceSelect.innerHTML = '<option value="">Nessuna provincia disponibile</option>';
			structureSelect.innerHTML = '<option value="">Nessuna struttura disponibile</option>';
			return;
		}

		const prestazione = Array.isArray(prestazioneData) ? prestazioneData[0] : prestazioneData;

		// Verifica che prestazione sia un oggetto valido
		if (!prestazione || typeof prestazione !== 'object') {
			console.error("Dati della prestazione non validi:", prestazioneData);
			prestazioneSelect.innerHTML = '<option value="">Dati prestazione non validi</option>';
			provinceSelect.innerHTML = '<option value="">Nessuna provincia disponibile</option>';
			structureSelect.innerHTML = '<option value="">Nessuna struttura disponibile</option>';
			return;
		}

		// MODIFICA 1: Creiamo una lista arricchita e unica di tutte le strutture disponibili
		// dal payload dei medici, che contiene tutti i dati di cui abbiamo bisogno.
		if (!prestazione.medico || !Array.isArray(prestazione.medico)) {
			console.error("Dati medici non trovati o non validi:", prestazione);
			prestazioneSelect.innerHTML = '<option value="">Dati medici non disponibili</option>';
			provinceSelect.innerHTML = '<option value="">Nessuna provincia disponibile</option>';
			structureSelect.innerHTML = '<option value="">Nessuna struttura disponibile</option>';
			return;
		}

		const allAvailableStructures = prestazione.medico.flatMap(medico => medico.strutture || []);
		const uniqueAvailableStructures = allAvailableStructures.filter(
			(structure, index, self) => index === self.findIndex(s => s.id_wp === structure.id_wp)
		);

		if (!uniqueAvailableStructures || uniqueAvailableStructures.length === 0) {
			prestazioneSelect.innerHTML = `<option value="${prestazioneId}">${prestazione.name || 'Prestazione'}</option>`;
			makeFieldsReadOnly([prestazioneSelect]);
			provinceSelect.innerHTML = '<option value="">Nessuna provincia disponibile</option>';
			structureSelect.innerHTML = '<option value="">Nessuna struttura disponibile</option>';
			return;
		}

		const prestazioneValue = prestazione.codice_onit || prestazione.id_wp;
		prestazioneSelect.innerHTML = '';
		prestazioneSelect.add(new Option(prestazione.name, prestazioneValue));
		makeFieldsReadOnly([prestazioneSelect]);
		updateSalesforceHiddenFields(prestazioneValue, [prestazione]);


		// MODIFICA 2: Creiamo un array di oggetti per le province, unico,
		// per avere sia il nome completo che la sigla.
		const provinceObjects = uniqueAvailableStructures.map(s => ({
			name: s.provincia,
			short: s.provincia_short
		})).filter(
			(province, index, self) => province.short && index === self.findIndex(p => p.short === province.short)
		);

		// Usiamo populateSelect per gestire l'oggetto {name, short}

		// Logica a cascata: Provincia -> Struttura
		provinceSelect.addEventListener('change', (event) => {
			const selectedProvinceShort = event.target.value;

			structureSelect.innerHTML = '<option value="">Seleziona una provincia</option>';
			structureSelect.disabled = true;
			if (doctorSelect) {
				doctorSelect.innerHTML = '<option value="">Seleziona una struttura</option>';
				doctorSelect.disabled = true;
			}

			if (!selectedProvinceShort) {
				return;
			}


			const filteredStructures = uniqueAvailableStructures.filter(s => s.provincia_short === selectedProvinceShort);

			populateSelect(structureSelect, filteredStructures, 'codice_onit', 'name', null, 'Seleziona una struttura...');
			structureSelect.disabled = false;
		});

		if (doctorSelect) {
			structureSelect.addEventListener('change', (event) => {
				const selectedStructureCodiceOnit = event.target.value;
				if (!selectedStructureCodiceOnit) {
					doctorSelect.innerHTML = '<option value="">Seleziona una struttura</option>';
					doctorSelect.disabled = true;
					return;
				}

				const filteredDoctors = prestazione.medico.filter(doctor =>
					doctor.strutture && doctor.strutture.some(s => s.codice_onit == selectedStructureCodiceOnit)
				);

				if (filteredDoctors.length === 0) {
					doctorSelect.innerHTML = '';
					doctorSelect.add(new Option('Nessun medico disponibile per questa struttura', ''));
					doctorSelect.disabled = true;
				} else {
					populateSelect(doctorSelect, filteredDoctors, 'codice_fiscale', 'nome', null, 'Seleziona un medico...');
					doctorSelect.disabled = false;
				}
			});
		}

		populateSelect(provinceSelect, provinceObjects, 'short', 'name', null, 'Seleziona una provincia...');
		provinceSelect.disabled = false;

	} catch (error) {
		console.error("Errore durante l'inizializzazione del form per prestazione:", error);
	}
}


// MAIN EXECUTION ROUTER
export default function gravityFormsApiProxy() {
	document.addEventListener('DOMContentLoaded', () => {
		// 1. Seleziona TUTTI i wrapper dei form di Gravity presenti nella pagina
		const formWrappers = document.querySelectorAll('.gform_wrapper');

		// 2. Esegui un ciclo su ciascun form trovato
		formWrappers.forEach(formWrapper => {
			// Controlla se il form ha il nostro campo "trigger"
			const apiTrigger = formWrapper.querySelector('.gf-api-trigger');
			if (!apiTrigger) {
				return; // Se non è un form con la nostra logica, salta al prossimo
			}

			const form = formWrapper.querySelector('form');
			if (!form) return;

			console.log(form);

			// Controlla i data-attributes per decidere quale scenario avviare
			const structureId = form.dataset.currentStructureId;
			const medicoId = form.dataset.currentMedicoId;
			const prestazioneId = form.dataset.currentPrestazioneId;

			// Avvia la funzione di inizializzazione corretta per QUESTO form specifico
			if (medicoId) {
				initializeMedicoForm(formWrapper, medicoId);
			} else if (prestazioneId && structureId) {
				initializePrestazioneForm(formWrapper, structureId, prestazioneId);
			} else if (structureId) {
				initializePreselectedForm(formWrapper, structureId);
			} else if (prestazioneId) {
				initializeCascadingPrestazioneForm(formWrapper, prestazioneId);
			} else {
				initializeDynamicSelects(formWrapper);
			}
		});
	});
}
